import {
  Component,
  ContentChildren,
  QueryList,
  ViewChild,
} from '@angular/core';
import { SwiperOptions } from 'swiper';

import { CarouselSlideDirective } from '../carousel';

@Component({
    selector: 'lui-resource-carousel',
    templateUrl: './resource-carousel.component.html',
    styleUrls: ['./resource-carousel.component.scss'],
    standalone: false
})
export class ResourceCarouselComponent {
  @ContentChildren(CarouselSlideDirective)
  slides!: QueryList<CarouselSlideDirective>;

  config: SwiperOptions = {
    slidesOffsetBefore: 20,
    slidesPerView: 2.2,
    spaceBetween: 40,
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    },
    breakpoints: {
      576: {
        slidesOffsetBefore: 180,
        slidesPerView: 3.2,
      },
      1400: {
        slidesOffsetBefore: 212,
        slidesPerView: 'auto',
      },
    },
  };
}
